module.exports = __webpack_public_path__ + "static/store-e8608206cf60067d0d0184fd4f5e2d9f.jpg";